<template>
  <BaseAutocomplete
    :label="label"
    :placeholder="placeholder"
    :items="questionTypes"
    v-model="type"
    item-text="title"
    item-value="value"
    hide-details
    :clearable="isClearable"
    :returnObject="false"
  />
</template>
<script>
export default {
  props: {
    label: String,
    placeholder: String,
    itemText: String,
    itemValue: String,
    multiple: Boolean,
    isClearable: Boolean,
  },
  data() {
    return {
      type: null,
    }
  },
  computed: {
    questionTypes() {
      return [
        {title: 'Trắc nghiệm 1 đáp án', value: 'single-choice'},
        {title: 'Trắc nghiệm nhiều đáp án', value: 'multiple-choice'},
        {title: 'Câu hỏi lựa chọn đúng/sai', value: 'true-false-choice'},
        {title: 'Trả lời ngắn', value: 'fill-blank'},
        {title: 'Câu hỏi nhóm', value: 'group'},
        {title: 'Điền trực tiếp vào câu hỏi', value: 'direct-fill-blank-group'},
      ]
    },
  },
  watch: {
    type: {
      handler(val) {
        this.$emit('input', val)
      },
      immediate: true,
    },
  },
}
</script>
